import * as Sentry from "@sentry/vue"
import "./bootstrap";
import "../css/app.css";
import "@/composables/autolink";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
});

import { createSSRApp, type App, type DefineComponent, h, markRaw, defineAsyncComponent } from "vue";
import { createInertiaApp, Link, Head } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "ziggy-js";
import BaseLayout from "@/layouts/BaseLayout.vue";
import { createPinia } from "pinia";
import { createHead } from "@vueuse/head";
import { useTableStore } from "@/stores";

const pinia = createPinia();
const head = createHead();

createInertiaApp({
  title: (title) => `${title}`,
  resolve: async (name) => {
    let page = await resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>("./pages/**/*.vue"));

    if (!page.default.layout && page.default.layout !== false) {
      page.default.layout = BaseLayout;
    }

    return page;
  },
  setup({ el, App, props, plugin }) {
    createSSRApp({ render: () => h(App, props) })
      .use(plugin)
      .use(pinia)
      .use(head)
      .use({
        install(app: App, options) {
          const store = useTableStore();
          store.columns = {
            text: markRaw(defineAsyncComponent({ loader: () => import("@/components/VColumnText.vue") })),
            bool: markRaw(defineAsyncComponent({ loader: () => import("@/components/VColumnBool.vue") })),
            status: markRaw(defineAsyncComponent({ loader: () => import("@/components/VColumnStatus.vue") })),
            link: markRaw(defineAsyncComponent({ loader: () => import("@/components/VColumnLink.vue") })),
            date: markRaw(defineAsyncComponent({ loader: () => import("@/components/VColumnDate.vue") })),
            user: markRaw(defineAsyncComponent({ loader: () => import("@/components/VColumnUser.vue") })),
          };
        },
      })
      .component("Link", Link)
      .component("Head", Head)
      .use(ZiggyVue)
      .mount(el);
  },
  progress: {
    color: "#4B5563",
  },
});
